import { Sparkles } from "lucide-react";

const SIZES = {
  sm: "p-1.5",
  md: "h-9 w-9",
} as const;

type BrianToggleButtonProps = {
  open: boolean;
  onToggle: () => void;
  size?: keyof typeof SIZES;
};

export default function BrianToggleButton({ open, onToggle, size = "md" }: BrianToggleButtonProps) {
  return (
    <button
      onClick={onToggle}
      aria-expanded={open}
      title={open ? "Close Brian" : "Ask Brian"}
      className={`flex items-center justify-center rounded-lg border transition-colors ${SIZES[size]} ${
        open
          ? "border-[#1D345F] bg-[#1D345F] text-white hover:bg-[#162847]"
          : "border-gray-200 text-[#1D345F] hover:border-[#1D345F] hover:bg-[#1D345F]/5"
      }`}
    >
      <Sparkles size={14} className={!open ? "brian-sparkle" : undefined} aria-hidden="true" />
    </button>
  );
}
